/* global self */

const CACHE_NAME = 'offline-cache-v1';
const OFFLINE_URLS = ['/', '/index.html'];

window.self.addEventListener('activate', (event) => {
    console.log('Service Worker activating.');
    event.waitUntil(
        caches.keys().then((cacheNames) => {
            return Promise.all(
                cacheNames.map((cacheName) => {
                    if (cacheName !== CACHE_NAME) {
                        console.log('Deleting old cache:', cacheName);
                        return caches.delete(cacheName);
                    }
                })
            );
        })
    );
    return window.self.clients.claim();
});

// Install: cache essential files
window.self.addEventListener('install', (event) => {
    console.log('Service Worker installing...');
    event.waitUntil(
        caches.open(CACHE_NAME).then((cache) => {
            console.log('Caching offline pages');
            return cache.addAll(OFFLINE_URLS);
        })
    );
    window.self.skipWaiting();
});

// Fetch: Network first, fall back to cache for offline
window.self.addEventListener('fetch', (event) => {
    const { request } = event;

    if (request.method !== 'GET') {
        return;
    }

    if (request.url.includes('chrome-extension://')) {
        return;
    }

    event.respondWith(
        fetch(request)
            .then((response) => {
                const responseClone = response.clone();

                if (
                    response.status === 200 &&
                    request.headers.get('accept')?.includes('text/html')
                ) {
                    caches.open(CACHE_NAME).then((cache) => {
                        cache.put(request, responseClone);
                    });
                }

                return response;
            })
            .catch(() => {
                return caches.match(request).then((response) => {
                    if (response) {
                        return response;
                    }

                    if (request.mode === 'navigate') {
                        return caches.match('/index.html');
                    }

                    return new Response('Offline - content not available', {
                        status: 503,
                        statusText: 'Service Unavailable',
                        headers: new Headers({
                            'Content-Type': 'text/plain',
                        }),
                    });
                });
            })
    );
});

// ✅ Handle notification display from postMessage
window.self.addEventListener('message', (event) => {
    if (event.data.type === 'SHOW_NOTIFICATION') {
        window.self.registration.showNotification(event.data.title, event.data.options);
    }
});

// ✅ Handle notification clicks
window.self.addEventListener('notificationclick', (event) => {
    console.log('Notification clicked:', event.notification.tag);
    event.notification.close();

    event.waitUntil(
        window.self.clients.matchAll({ type: 'window', includeUncontrolled: true }).then((clientList) => {
            // Try to focus existing window
            for (let i = 0; i < clientList.length; i++) {
                if (clientList[i].url === '/' && 'focus' in clientList[i]) {
                    return clientList[i].focus();
                }
            }
            // Open new window if none found
            if (window.self.clients.openWindow) {
                return window.self.clients.openWindow('/');
            }
        })
    );
});

// ✅ Handle notification close
window.self.addEventListener('notificationclose', (event) => {
    console.log('Notification closed:', event.notification.tag);
});

// Background sync: send pending data (optional)
window.self.addEventListener('sync', (event) => {
    if (event.tag === 'sync-pending') {
        event.waitUntil(syncPendingData());
    }
});

async function syncPendingData() {
    console.log('Background sync triggered');
    // Placeholder for background sync
}

// Handle push notifications from backend (optional)
window.self.addEventListener('push', (event) => {
    const data = event.data?.json() ?? {};
    const title = data.title || 'Notification';
    const options = {
        body: data.body || '',
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        tag: data.tag || 'push-notification',
    };

    event.waitUntil(window.self.registration.showNotification(title, options));
});